export default __webpack_public_path__ + "static/media/Vonder_Particle_OuterPortal.f6be6126.png";